export const createTakeoverCopy = {
  linkCard: {
    title: '商品链接',
    step: '第 01 步 · 商品接入',
    placeholder: '粘贴你的商品链接，其余交给 AI',
    emptyHint: '支持 Shopify、独立站商品页。贴上之后我会读取标题、价格、主图与卖点。',
    sample: '用示例链接',
    statusLoading: '正在读取…',
    statusOk: '识别完成',
    statusBad: '读取失败',
    errorBody: '换一个链接我再试一次——在这之前后面几步都不会开始。',
    retry: '换一个链接',
  },
  planCard: {
    badge: 'AI 已生成',
    title: '投放策略',
    step: '第 03 步 · 投放策略',
    confirm: '确认并投放',
    editAll: '调整策略',
    edit: '调整',
    footnote: '本页仅需 1 次确认；调整后将重新测算预计成效。',
  },
  forecastCard: {
    title: '预计成效',
    window: '按同商品上一轮成绩测算，投放期 {days} 天',
  },
  creativeCard: {
    badge: 'AI',
    title: '素材已准备',
    step: '第 04 步',
  },
} as const
